import {
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

export const useDropdownToggle = (externalRef?: React.Ref<HTMLDivElement>) => {
  const ref = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  // Nếu có externalRef truyền vào thì sync nó với internalRef
  useImperativeHandle(externalRef, () => ref.current as HTMLDivElement, []);

  const openDropdown = () => {
    setOpen(true);
  };

  const closeDropdown = useCallback(() => {
    setOpen(false);
  }, []);

  useEffect(() => {
    const handleClickOutsite = (e: MouseEvent) => {
      if (!ref.current?.contains(e.target as Node)) closeDropdown();
    };

    const handleKeydown = (e: KeyboardEvent) => {
      if (e.key === "Escape" && open) {
        // Fix issues where dropdown in modal
        e.stopImmediatePropagation();
        e.stopPropagation();
        closeDropdown();
      }
    };

    window.addEventListener("click", handleClickOutsite);
    window.addEventListener("keydown", handleKeydown, true);

    return () => {
      window.removeEventListener("click", handleClickOutsite);
      window.removeEventListener("keydown", handleKeydown, true);
    };
  }, [open, closeDropdown]);

  return {
    open,
    closeDropdown,
    openDropdown,
    ref,
  };
};
